import { checkUsernameExists } from '@/domain/services/auth/authService';

/**
 * UsernameExistsUseCase
 *
 * Checks if a username already exists.
 * Delegates to authService which handles Firestore access and error handling.
 */
export class UsernameExistsUseCase {
    async execute(username: string, currentUserId?: string): Promise<boolean> {
        return checkUsernameExists(username, currentUserId);
    }
}

export const usernameExistsUseCase = new UsernameExistsUseCase();
